// This was POC to send tracking events to active campaign but will be removed once transfered to the backend
export const accountCreated = (email) => ({
  eventName: 'Create_new_account',
  email,
})
